import { fork } from 'redux-saga/effects';

import BranchGateway from '~apis/branch';
import { RootSagaReturnType } from '~types/saga';

import watchGetBranchListing from './getBranchListing';
import watchGetRegionListing from './getRegionListing';
import watchCreateNewRegion from './createNewRegion';
import watchCreateNewBranch from './createNewBranch';
import watchGetAllRegions from './getAllRegions';
import watchGetAllBranches from './getAllBranches';
import watchEditBranchDetails from './editBranchDetails';
import watchEditRegionDetails from './editRegionDetails';

export default (api: BranchGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetBranchListing, api);
        yield fork(watchGetRegionListing, api);
        yield fork(watchCreateNewRegion, api);
        yield fork(watchCreateNewBranch, api);
        yield fork(watchGetAllRegions, api);
        yield fork(watchGetAllBranches, api);
        yield fork(watchEditBranchDetails, api);
        yield fork(watchEditRegionDetails, api);
    }

    return {
        rootSaga,
    };
};
